import request from '@/utils/httpClient'

// 业务联系人列表
export function businessConcatsList(id: number) {
  return request({
    url: `business/${id}/actions/contacts`,
    method: 'get'
  })
}

// 业务联系人列表
export function businessEngineersList(id: number) {
  return request({
    url: `business/${id}/actions/engineers`,
    method: 'get'
  })
}

// 获取业务市场费列表
export function marketFeeList(id: number) {
  return request({
    url: `business/${id}/actions/marketFee`,
    method: 'get'
  })
}

// 设置业绩类型
export function setAchieve(id: number | string, data?: object) {
  return request({
    url: `business/${id}/actions/achieve`,
    method: 'put',
    data
  })
}

// 设置业绩类型
export function customerConfirm(id: number | string, data?: object) {
  return request({
    url: `business/${id}/actions/customerConfirm`,
    method: 'put',
    data
  })
}

// 外包费发票
export function outsourceFeeTicketList(id: number | string) {
  return request({
    url: `business/${id}/actions/outsourceFeeTicket`,
    method: 'get'
  })
}

// 取消业务
export function cancelBusiness(id: number | string, data: any) {
  return request({
    url: `business/${id}/actions/cancel`,
    method: 'delete',
    data
  })
}

export declare type BusinessActionType = 'edit' | 'cancel' | 'addMarketFee' | 'addOutsourceFee'
export const verifyBusinessAction = (id: number, action: BusinessActionType) => request({
  url: `business/${id}/actions/verify/${action}`,
  method: 'get'
})
